import React from 'react';
import { LocalizedMeasurementQU } from '../../../../types';

import styles from '../RegionReport.css';

interface SummaryItemProps {
  defaultValue?: string;
  localizedMeasurement?: LocalizedMeasurementQU;
  label: string;
  dataTestId: string;
}

export const SummaryItem: React.FC<SummaryItemProps> = ({
  label,
  dataTestId,
  localizedMeasurement,
  defaultValue = '-'
}) => {
  const displayValue = localizedMeasurement?.q ?? defaultValue;
  const displayValueUnit = localizedMeasurement?.u ? ` (${localizedMeasurement?.u})` : '';
  return (
    <div>
      <p data-test-id={`frr-region-report-summary-${dataTestId}-q`}>
        <span
          className={styles.summaryQuantity}>
          {displayValue}
        </span>
      </p>
      <p className={styles.headerSummary} data-test-id={`frr-region-report-summary-${dataTestId}-u`}>
        {label}
        <br />
        <span className={styles.summaryUnit}>{displayValueUnit}</span>
      </p>
    </div>
  );
}
